import script from "./MainReport.vue?vue&type=script&setup=true&lang=js"
export * from "./MainReport.vue?vue&type=script&setup=true&lang=js"

import "./MainReport.vue?vue&type=style&index=0&id=64100d6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64100d6d"]])

export default __exports__